import http from "./apiClient";

const BASE_PATH = "/notifications/preferences";

const normalizeList = (payload) => {
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.preferences)) return payload.preferences;
  if (Array.isArray(payload?.data?.preferences)) return payload.data.preferences;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

export async function listNotificationPreferences() {
  const { data } = await http.get(BASE_PATH);
  return normalizeList(data);
}

export async function upsertNotificationPreference(topic, { channel = "EMAIL", enabled }) {
  const url = `${BASE_PATH}/${encodeURIComponent(topic)}`;
  const params = {};
  if (channel) params.channel = channel;
  const body = { enabled };
  const { data } = await http.put(
    url,
    body,
    Object.keys(params).length ? { params } : undefined
  );
  return data;
}

export async function listNotificationSubscribers(topic, channel = "EMAIL") {
  if (!topic) throw new Error("topic is required");
  const params = { topic };
  if (channel) params.channel = channel;
  const { data } = await http.get("/admin/notifications/subscribers", { params });
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.subscribers)) return data.subscribers;
  return [];
}

export async function updateNotificationSubscriber(userId, { topic, channel = "EMAIL", enabled }) {
  if (!userId) throw new Error("userId is required");
  if (!topic) throw new Error("topic is required");
  const safeUser = encodeURIComponent(userId);
  const url = `/admin/notifications/subscribers/${safeUser}`;
  const body = { topic, channel, enabled };
  const { data } = await http.put(url, body);
  return data;
}
